<template>
    <v-defaults-provider scoped>
        <div>
            <RouterView />
        </div>
    </v-defaults-provider>
</template>

<script setup lang="ts"></script>
<style lang="scss"></style>
